/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsSetPassword
 */
export interface MelcoModelsSetPassword {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsSetPassword
     */
    user_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsSetPassword
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsSetPassword
     */
    new_password?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MelcoModelsSetPassword
     */
    accept_service_terms?: boolean;
}

export function MelcoModelsSetPasswordFromJSON(json: any): MelcoModelsSetPassword {
    return MelcoModelsSetPasswordFromJSONTyped(json, false);
}

export function MelcoModelsSetPasswordFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsSetPassword {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_name': !exists(json, 'user_name') ? undefined : json['user_name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'new_password': !exists(json, 'new_password') ? undefined : json['new_password'],
        'accept_service_terms': !exists(json, 'accept_service_terms') ? undefined : json['accept_service_terms'],
    };
}

export function MelcoModelsSetPasswordToJSON(value?: MelcoModelsSetPassword | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_name': value.user_name,
        'code': value.code,
        'new_password': value.new_password,
        'accept_service_terms': value.accept_service_terms,
    };
}


